import React from 'react';
import '../../styles/onboardingFlow/onboardingComponents/businessTypeSelector.scss';
import BriefcaseIcon from '../../assets/onboarding/common/Briefcase.svg';
import UsersThreeIcon from '../../assets/onboarding/common/UsersThree.svg';

interface BusinessTypeSelectorProps {
  selectedType: 'business' | 'agency';
  onSelect: (type: 'business' | 'agency') => void;
  /** When set, these options are disabled (e.g. after creating a shop). */
  disabledTypes?: ('business' | 'agency')[];
  /** Called when user clicks a disabled option (e.g. to show an explanation popup). */
  onDisabledTypeClick?: (type: 'business' | 'agency') => void;
}

const BusinessTypeSelector: React.FC<BusinessTypeSelectorProps> = ({
  selectedType,
  onSelect,
  disabledTypes = [],
  onDisabledTypeClick,
}) => {
  const handleCardClick = (type: 'business' | 'agency') => {
    if (disabledTypes.includes(type)) {
      onDisabledTypeClick?.(type);
      return;
    }
    onSelect(type);
  };

  return (
    <div className='businessTypeSelector'>
      <div
        className={`businessTypeSelector__card ${
          selectedType === 'business'
            ? 'businessTypeSelector__card--selected'
            : ''
        } ${disabledTypes.includes('business') ? 'businessTypeSelector__card--disabled' : ''}`}
        onClick={() => handleCardClick('business')}
      >
        <div className='businessTypeSelector__card-icon'>
          <img src={BriefcaseIcon} alt='Business' />
        </div>
        <div className='businessTypeSelector__card-content'>
          <h3 className='businessTypeSelector__card-title'>Enterprise</h3>
          <p className='businessTypeSelector__card-subtitle'>
            We manage marketing for our own business
          </p>
        </div>
      </div>

      <div
        className={`businessTypeSelector__card ${
          selectedType === 'agency'
            ? 'businessTypeSelector__card--selected'
            : ''
        } ${disabledTypes.includes('agency') ? 'businessTypeSelector__card--disabled' : ''}`}
        onClick={() => handleCardClick('agency')}
      >
        <div className='businessTypeSelector__card-icon'>
          <img src={UsersThreeIcon} alt='Agency' />
        </div>
        <div className='businessTypeSelector__card-content'>
          <h3 className='businessTypeSelector__card-title'>Agency</h3>
          <p className='businessTypeSelector__card-subtitle'>
            We manage marketing for multiple client brands
          </p>
        </div>
      </div>
    </div>
  );
};

export default BusinessTypeSelector;
